// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__38WAN","savePackageButton":"ClientWallet_savePackageButton__3FOhM"};